import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import Footer from "./shared/Footer";
import Progress from "./components/projects/progress";
class App extends Component {
  state = {};
  componentDidMount() {
    this.onRouteChanged();
  }

  render() {
    let navbarComponent = !this.state.isFullPageLayout ? <Navbar /> : "";
    let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar /> : "";
    let footerComponent = !this.state.isFullPageLayout ? <Footer /> : "";
    let createProjectRoutes = [
      "/projects/create/general-information",
      "/projects/create/project-funding",
      "/projects/create/related-projects",
      "/projects/create/project-locations",
      "/projects/create/project-resources",
      "/projects/create/main-objective",
      "/projects/create/specific-objectives",
      "/projects/create/implementing-entities",
      "/projects/create/beneficiary-entities",
      "/projects/create/additional-notes",
    ];
    let progress = createProjectRoutes.includes(window.location.pathname) ? (
      <Progress />
    ) : (
      ""
    );

    return (
      <div className="container-scroller">
        {sidebarComponent}
        <div className="container-fluid page-body-wrapper">
          {navbarComponent}

          <div className="main-panel">
            <div className="content-wrapper">
              {progress}
              <AppRoutes />
            </div>
            {footerComponent}
          </div>
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    console.log("ROUTE CHANGED");
    const fullPageLayoutRoutes = [
      "/",
      "/profile/login",
      "/error/401",
      "/admin/login",
      "/admin/add-sso-credentials",
      "/profile/login-2",
      "/profile/register-1",
      "/profile/register-2",
      "/profile/lockscreen",
      "/error/404",
      "/error/500",
      "/general-pages/landing-page",
    ];

    for (let i = 0; i < fullPageLayoutRoutes.length; i++) {
      if (this.props.location.pathname === fullPageLayoutRoutes[i]) {
        this.setState({
          isFullPageLayout: true,
        });
        document
          .querySelector(".page-body-wrapper")
          .classList.add("full-page-wrapper");
        break;
      } else {
        this.setState({
          isFullPageLayout: false,
        });
        document
          .querySelector(".page-body-wrapper")
          .classList.remove("full-page-wrapper");
      }
    }
  }
}
export default withRouter(App);
